"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const svg_inline_react_1 = __importDefault(require("svg-inline-react"));
const styled_components_1 = __importDefault(require("styled-components"));
const globalVariables_1 = require("../../globalVariables");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const useFetchSvg_1 = __importDefault(require("../../helpers/Hooks/useFetchSvg"));
const WeatherIcon_1 = __importDefault(require("./WeatherIcon"));
const DayForecastWrapper = styled_components_1.default.div `
  width: 100%;
  max-width: ${(props) => props.maxWidthHeader}px;
  color: #ffffff;
  margin: 16px auto 0;
  bottom: 0;
  display: flex;
  align-items: stretch;
  text-align: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 1vmin;
  @media (orientation: landscape) {
    height: 40vh;
    flex-direction: row;
  }
  .showOnPortrait {
    @media (orientation: landscape) {
      display: none;
    }
  }
  @media (max-height: 300px) {
    margin: 0 auto;
  }

  .weather-icon {
    height: 8vh;

    svg {
      height: 100%;
    }
    @media (orientation: landscape) {
      height: 14vh;
      svg {
        height: 80%;
      }
    }
  }
`;
const DayWrapperCard = styled_components_1.default.div `
  color: #ffffff;
  border-radius: 1vmin;
  display: flex;
  justify-content: space-between;

  &.achental {
    color: #9A141A;
  }

  &.bareiss {
    @media (orientation: landscape) {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: ${() => "url( /images/other/bareissTransparent.png )"};
    }
  }

  @media (orientation: landscape) {
    height: 32vmin;
    flex-direction: column;
  }
`;
const DayName = styled_components_1.default.div `
  font-size: 5vmin;
  display: flex;
  align-items: center;
  flex-basis: 30%;
  color:inherit;

  @media (orientation: landscape) {
    font-size: 4vmin;
    justify-content: center;
  }
`;
const TemperatureContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 10%;
  color: inherit;
`;
const MaxTemperature = styled_components_1.default.div `
  font-size: 5vmin;
  color: inherit;
  margin-right: 16px;
  @media (orientation: landscape) {
    font-size: 5vmin;
  }
`;
const MinTemperature = styled_components_1.default.div `
  font-size: 5vmin;
  color: inherit;
  @media (orientation: landscape) {
    font-size: 3vmin;
  }
`;
const Provider = styled_components_1.default.div `
  flex-grow: 1;
  @media (orientation: landscape) {
    text-align: left;
  }

  i {
    margin-right: 4px;
    position: relative;
    top: 2px;
  }

  path {
    fill: ${(props) => props.theme.palette.mainAppColor.main};
  }
`;
const Day = styled_components_1.default.div `
  flex-basis: 25%;
`;
const DayForecast = (props) => {
    const { venue } = props;
    const renderDayForecast = (forecast) => {
        const date = new Date(forecast.date);
        const dayOfTheWeek = i18n_js_1.default.t("dictionary.dayNames")[date.getDay()];
        const isNotDs = process.env.PLATFORM !== "ds";
        const bareissClass = isNotDs && venue && venue.brandSlug === "bareiss" ? "bareiss" : "";
        const isDasAchental = venue && venue.brandSlug === "das-achental" ? "achental" : "";
        return (react_1.default.createElement(DayWrapperCard, { className: `${bareissClass} ${isDasAchental}` },
            react_1.default.createElement(DayName, null, dayOfTheWeek),
            react_1.default.createElement(WeatherIcon_1.default, { symbol: forecast.symbol, whiteTransparentVariant: true }),
            react_1.default.createElement(TemperatureContainer, null,
                react_1.default.createElement(MaxTemperature, null,
                    forecast.max,
                    "\u00B0"),
                react_1.default.createElement(MinTemperature, null,
                    forecast.min,
                    "\u00B0"))));
    };
    const loadedSvg = props.providerIcon ? (0, useFetchSvg_1.default)(props.providerIcon) : null;
    return (react_1.default.createElement(DayForecastWrapper, { currentWeatherIsBad: props.currentWeatherIsBad, maxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_HEADER },
        react_1.default.createElement(Day, null, renderDayForecast(props.forecast[0])),
        react_1.default.createElement(Day, null, renderDayForecast(props.forecast[1])),
        react_1.default.createElement(Day, null, renderDayForecast(props.forecast[2])),
        react_1.default.createElement(Day, null, renderDayForecast(props.forecast[3])),
        react_1.default.createElement(Day, { className: "showOnPortrait" }, renderDayForecast(props.forecast[4])),
        props.providerIcon && props.providerText && (react_1.default.createElement(Provider, null,
            react_1.default.createElement(svg_inline_react_1.default, { src: loadedSvg }),
            react_1.default.createElement("span", null, props.providerText)))));
};
const mapStoreToProps = (store) => ({
    venue: store.getValue("venue"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(DayForecast);
